import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import SC from "./style";
import CustomizedList from "../List";
import themee from "@theme";
import { Divider } from "@mui/material";
import InnoIcons from "@InnoIcons/";
import TooltipText from "components/TooltipText";
import { useNavigate } from "react-router";

const drawerWidth = 230;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "#f7f9f7",
  marginTop: "65px",
  [theme.breakpoints.down("sm")]: {
    marginTop: "58px",
  },
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  marginTop: "65px",
  backgroundColor: "#f7f9f7",
  [theme.breakpoints.down("sm")]: {
    marginTop: "58px",
  },
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
    },
  }),
}));

const DrawerComponent = ({ navItems }) => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleBackClick = () => {
    navigate("/");
  };

  return (
    <Drawer variant="permanent" open={open}>
      <Divider />
      <div style={{ display: "flex" }}>
        {open && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <InnoIcons.ArrowBackIcon
              sx={{
                cursor: "pointer",
                borderLeft: "4px outset",
                borderImageSource: `${themee.gradient.themeGradient}`,
                borderImageSlice: 1,
              }}
              onClick={handleBackClick}
            />
            <p
              style={{
                margin: "15px 50px 15px 5px",
                padding: "5px 5px 5px 5px",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              <TooltipText title={"Admin Settings"} />
            </p>
          </div>
        )}
      </div>
      <CustomizedList items={navItems} open={open} />
    </Drawer>
  );
};

export default DrawerComponent;
